import { combineReducers } from 'redux';

import currentUser from './currentUser';
import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *  data: import('./data').UserDataReducer,
 *  ui: import('./ui').UserUiReducer,
 *  currentUser: import('./currentUser').CurrentUserReducer
 * }} UserReducer
 */
export default combineReducers({
  data,
  ui,
  currentUser,
});
